import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import { useDispatch, useSelector } from 'react-redux';
import { TYPE } from '../store/models/sessionChats';

const PhysicianSessionChatJoinModule = ({ permanentJoinId, id }) => {
  const dispatch = useDispatch();
  const { errors } = useSelector(state => state[TYPE]);
  const isLoading = useSelector(state => state.loading.effects[TYPE].joinChat);
  const joinChat = useCallback(
    () => dispatch[TYPE].joinChat({ permanentJoinId, id }),
    [dispatch, id, permanentJoinId],
  );
  const [submitted, setSubmitted] = useState(false);

  const { t } = useTranslation('physician');
  const hasJoinedSuccessfully = !isLoading && submitted && !errors;

  useEffect(() => {
    joinChat();
    setSubmitted(true);
  }, [joinChat]);

  useEffect(() => {
    if (!isLoading && submitted) {
      if (!errors) {
        showSuccessToast(t('messenger:PhysicianSessionChatJoinModule.success'), null, {
          toastId: 'sessionChatJoinSuccess',
        });
        return;
      }
      showAlertToast(
        t('messenger:PhysicianSessionChatJoinModule.errors.title'),
        t('messenger:PhysicianSessionChatJoinModule.errors.text'),
        {
          toastId: 'sessionChatJoinFailed',
        },
      );
    }
  }, [isLoading, errors, submitted]);

  if (hasJoinedSuccessfully) {
    return <Redirect to="/" />;
  }

  return null;
};

PhysicianSessionChatJoinModule.propTypes = {
  permanentJoinId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default PhysicianSessionChatJoinModule;
